import React from 'react';
import { useNavigate } from 'react-router-dom';

const LockedPage = ({ featureName = 'Rewrite' }) => {
    const navigate = useNavigate();

    return (
        <div className="flex-1 flex items-center justify-center p-8 relative overflow-hidden">
            {/* Background decorative elements */}
            <div style={{
                position: 'absolute',
                top: '-20%',
                right: '-10%',
                width: '500px',
                height: '500px',
                borderRadius: '50%',
                background: 'radial-gradient(circle, rgba(99,102,241,0.06) 0%, transparent 70%)',
                pointerEvents: 'none',
            }} />
            <div style={{
                position: 'absolute',
                bottom: '-15%',
                left: '-5%',
                width: '400px',
                height: '400px',
                borderRadius: '50%',
                background: 'radial-gradient(circle, rgba(168,85,247,0.05) 0%, transparent 70%)',
                pointerEvents: 'none',
            }} />

            <div style={{
                textAlign: 'center',
                maxWidth: '420px',
                animation: 'lockedFadeIn 0.6s ease-out',
            }}>
                {/* Lock Icon Container */}
                <div style={{
                    position: 'relative',
                    width: '120px',
                    height: '120px',
                    margin: '0 auto 32px',
                }}>
                    {/* Outer ring pulse */}
                    <div style={{
                        position: 'absolute',
                        inset: '0',
                        borderRadius: '50%',
                        border: '2px solid rgba(99,102,241,0.15)',
                        animation: 'lockedPulse 2.5s ease-in-out infinite',
                    }} />
                    {/* Middle ring */}
                    <div style={{
                        position: 'absolute',
                        inset: '10px',
                        borderRadius: '50%',
                        border: '2px solid rgba(99,102,241,0.1)',
                        animation: 'lockedPulse 2.5s ease-in-out infinite 0.3s',
                    }} />
                    {/* Icon circle */}
                    <div style={{
                        position: 'absolute',
                        inset: '20px',
                        borderRadius: '50%',
                        background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 50%, #a855f7 100%)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        boxShadow: '0 8px 32px rgba(99,102,241,0.3), 0 0 0 6px rgba(99,102,241,0.08)',
                    }}>
                        <span className="material-symbols-outlined" style={{
                            fontSize: '36px',
                            color: 'white',
                            animation: 'lockedShake 3s ease-in-out infinite',
                        }}>
                            lock
                        </span>
                    </div>
                </div>

                {/* Title */}
                <h2 style={{
                    fontSize: '24px',
                    fontWeight: '800',
                    letterSpacing: '-0.02em',
                    marginBottom: '16px',
                }} className="text-slate-800 dark:text-white">
                    Akan Datang
                </h2>

                {/* Description */}
                <p style={{
                    fontSize: '15px',
                    lineHeight: '1.7',
                    marginBottom: '32px',
                }} className="text-slate-400 dark:text-slate-500">
                    Fitur ini masih dalam pembangunan dan belum tersedia untuk pengguna umum.
                </p>


            </div>

            {/* CSS Animations */}
            <style>{`
                @keyframes lockedFadeIn {
                    from {
                        opacity: 0;
                        transform: translateY(20px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }
                @keyframes lockedPulse {
                    0%, 100% {
                        transform: scale(1);
                        opacity: 1;
                    }
                    50% {
                        transform: scale(1.08);
                        opacity: 0.5;
                    }
                }
                @keyframes lockedShake {
                    0%, 100% {
                        transform: rotate(0deg);
                    }
                    15% {
                        transform: rotate(-8deg);
                    }
                    30% {
                        transform: rotate(6deg);
                    }
                    45% {
                        transform: rotate(-4deg);
                    }
                    60% {
                        transform: rotate(0deg);
                    }
                }
            `}</style>
        </div>
    );
};

export default LockedPage;
